import styled, { keyframes, css } from 'styled-components';
import { themeGet } from 'modules/v2/foundation/theme';
const fadeOut = keyframes `
  0% {
    opacity: 1;
  }
  
  100% {
    opacity: 0;
    display: none;
    pointer-events: none; /* makes the cursor interact with the content instead of the hidden loader */
  }
`;
const fadeOutStyles = css `
  animation: ${fadeOut} 0.2s ease-in-out forwards;
`;
export const Container = styled.div `
  position: relative;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
`;
export const Overlay = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ $transparent }) => $transparent
    ? css `
          ${themeGet('colors.gray.50')}70
        `
    : themeGet('colors.background.50')};
  ${({ $enabled }) => !$enabled && fadeOutStyles};
`;
export const LoaderContainer = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: ${({ $position }) => ($position === 'center' ? 'center' : 'flex-start')};
  align-items: center;
  ${({ $enabled }) => !$enabled && fadeOutStyles};
`;
export const ContentContainer = styled.div `
  width: 100%;
  height: 100%;
  ${({ $transparent, $enabled }) => $enabled && $transparent && `filter: blur(0.035rem);`};
  transition: filter 0.2s ease-in-out;
`;
